import React from "react";
import "./RubriqueNav.css";
import { RUBRIQUES } from "../../config/rubriques";

const getPaginationItems = (total, current) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i);
  const items = [];
  items.push(0);
  if (current > 3) items.push("...");
  for (let i = Math.max(1, current - 1); i <= Math.min(total - 2, current + 1); i++) {
    items.push(i);
  }
  if (current < total - 4) items.push("...");
  items.push(total - 1);
  return items;
};

const RubriqueNav = ({ goNext, goPrev, goTo, suivante, precedente, indexCourant, total }) => {
  return (
    <div className="rnav-bar">
      <button className="rnav-btn rnav-btn--prev" onClick={goPrev} disabled={!precedente}>
        <span className="rnav-arrow">←</span>
        <span className="rnav-label">
          <span className="rnav-hint">Précédent</span>
          <span className="rnav-name">{precedente ? precedente.label : "—"}</span>
        </span>
      </button>

      <div className="rnav-pagination" style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap", justifyContent: "center" }}>
        <select
          className="rnav-select"
          value={indexCourant}
          onChange={(e) => goTo(Number(e.target.value))}
          aria-label="Aller à une section"
          style={{ padding: "9px 14px", borderRadius: "9px", border: "1px solid #cbd5e1", background: "#fff", fontSize: "14px", fontWeight: 600, color: "#1e293b", cursor: "pointer", maxWidth: "min(62vw, 380px)", boxShadow: "0 1px 2px rgba(0,0,0,.05)" }}>
          {RUBRIQUES.map((r, i) => (
            <option key={r.id} value={i}>{i + 1}. {r.label}</option>
          ))}
        </select>
        <span style={{ fontSize: "13px", fontWeight: 700, color: "#64748b", whiteSpace: "nowrap" }}>{indexCourant + 1} / {RUBRIQUES.length}</span>
      </div>

      <button className="rnav-btn rnav-btn--next" onClick={goNext} disabled={!suivante}>
        <span className="rnav-label">
          <span className="rnav-hint">Suivant</span>
          <span className="rnav-name">{suivante ? suivante.label : "—"}</span>
        </span>
        <span className="rnav-arrow">→</span>
      </button>
    </div>
  );
};

export default RubriqueNav;